// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
	width: 100%;
	text-align: left;
	border: none;
    border-collapse: collapse;
}

td:first-child {
    padding-left: 5px;
}

td:last-child {
    text-align: right;
}

td {
	padding: 0;
	text-align: left;
	text-overflow: clip;
	overflow: hidden;
	border: none;
	vertical-align: middle;
}

tr:nth-child(odd) {
    background-color: #eef;
}

tr:nth-child(even) {
    background-color: #fafaff;
}`, "",{"version":3,"sources":["webpack://./src/css/table.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,gBAAgB;CAChB,YAAY;IACT,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,YAAY;CACZ,sBAAsB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["table {\n\twidth: 100%;\n\ttext-align: left;\n\tborder: none;\n    border-collapse: collapse;\n}\n\ntd:first-child {\n    padding-left: 5px;\n}\n\ntd:last-child {\n    text-align: right;\n}\n\ntd {\n\tpadding: 0;\n\ttext-align: left;\n\ttext-overflow: clip;\n\toverflow: hidden;\n\tborder: none;\n\tvertical-align: middle;\n}\n\ntr:nth-child(odd) {\n    background-color: #eef;\n}\n\ntr:nth-child(even) {\n    background-color: #fafaff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
